<template>
    <div>

        <div class="row" :style="{width: width+'px', height: height+'px', margin: '0 auto'}">
            <img @click="isImageModalActive = true" 
                :style="{width: '100%', height: height+'px', cursor: 'pointer', borderRadius: borderRadius?'50%':''}" 
                 style="border-style: dashed; border-color: #eee; border-width: 1px;"
                 :src="getImagePath" alt="" srcset="">

            <a class="button is-small" v-if="!hideUpload" :title="$t('message.clickToUpload')" style="top: 0px; position: relative; width: 100px;" @click="openFileChooser()">
                <i class="material-icons" style="font-size: 16px;">cloud_upload</i>&nbsp;
            </a>
                
        </div>
        <p>
            &nbsp;
        </p>
        <p>
            &nbsp;
        </p>
        <input type="file" ref="myFileChooser" :id="elementId" @change="uploadImageToCDN" accept="image/*" style="display: none;">

        <b-modal :active.sync="isImageModalActive">
            <div style="background-color: white">
            <p class="image is-4by3">
                <img :src="getImagePath">
            </p>
            </div>
        </b-modal>  
    </div>
  
</template>

<script>
import axios from 'axios'
import * as accessTokenInfo from "../../store/accessToken";

export default {
    props: ['imgPath', 'width', 'height', 'elementId', 'hideUpload', 'borderRadius'],
    data() {
        return {
            imageUploadState: {
                currentState: null,
                path: '/assets/company-logo.png'
            },
            isImageModalActive: false
        }
    },
    computed: {
        getImagePath() {
            
            this.imageUploadState.path = this.imgPath

            if(this.imageUploadState.path != null && this.imageUploadState.path.length>0) {
                
            } else {
                this.imageUploadState.path = '/assets/company-logo.png'
            }
            
            return this.imageUploadState.path
        }
    },
    methods: {
        openFileChooser(event) {
            const elem = this.$refs.myFileChooser
            
            elem.click()
        },
        uploadImageToCDN(event) {
            
            let data = new FormData();
            
            data.append('file', document.getElementById(this.elementId).files[0]);

            axios.post('/upload-image/index.php', data, accessTokenInfo.accessTokenInfo())
            .then(res => {
                
                if(res.data.status) {
                    this.imageUploadState.path = res.data.image_path
                    this.sendImageBack()
                } else {
                    this.imageUploadState.path = ''
                    this.imageUploadState.currentState = null
                }

            }).catch(error => {
                //console.log(error)
                this.imageUploadState.path = ''
                this.imageUploadState.currentState = null
            })
            
        },
        sendImageBack() {
            
            this.$emit('changed', this.imageUploadState.path)
            this.imageUploadState.path = ''
            this.imageUploadState.currentState = null
            
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/UI/Images.vue